import Layout from "@/components/Layout";
import { AOWizard } from "@/components/wizard/AOWizard";

const NouvelAppelOffres = () => {
  return (
    <Layout>
      <AOWizard />
    </Layout>
  );
};

export default NouvelAppelOffres;